import { CLUSTER_API } from '../API/BASE_URL';

export const getDocsRoom = async () => {
  const response = await fetch(CLUSTER_API + 'room/documentations/', {
    method: 'GET',
  });

  const data = await response.json();
  return data;
};
